import React, { useState, useEffect, useCallback } from "react";
import cn from "classnames";

import styles from "screen/assets/Asset.module.scss";
import Admin from "components/userportal/Admin";
import Operator from "components/userportal/Operator";
import Driver from "components/userportal/Driver";
import RoleList from "components/userportal/RoleList";
import { Link, useHistory } from "react-router-dom";
import Master from "../Master";

var tempTigger;
var tabTemp = "inactive";

function UserListView(props) {
  const history = useHistory();
  const [table, setTable] = useState(
    props.location?.state?.table ? props.location.state.table : 0
  );
  const [userCount, setUserCount] = useState(0);

  useEffect(() => {
    tabTemp = "inactive";
    tempTigger = !props.history?.location?.state?.compomentRenderType
      ? "init"
      : props.history?.location?.state?.compomentRenderType === "amhitted"
      ? "amhitted"
      : props.history?.location?.state?.compomentRenderType === "view"
      ? "view"
      : "init";
  }, [
    history?.location?.state?.compomentRenderType ||
      props.history?.location?.state?.compomentRenderType,
  ]);

  useEffect(() => {
    localStorage.setItem("activeTabCount", "usersAsset");
    window.onload = () => {
      setTable(0);
    };
  }, []);

  return (
    <>
      <h2
        id="UserList_header_text"
        className={cn(styles.medium_title, styles.medium_title_layout)}
      >
        {"Users"}
      </h2>
      <div className={cn(styles.flex6_spacer)} />
      <div id="UserList_Total_count_block" className={cn(styles.flex5_item)}>
        <div
          id="UserList_Total_count_block1"
          className={cn(styles.block2, styles.block2_layout)}
        >
          <div
            id="UserList_Total_count_block2"
            className={cn(styles.block2_item)}
          >
            <div
              id="UserList_Total_count_container"
              className={cn(styles.block4, styles.block4_layout)}
            >
              <div
                id="UserList_Total_count_background"
                className={cn(styles.box3, styles.box3_layout)}
                style={{ backgroundColor: " rgb(64, 111, 211)" }}
              >
                <img
                  id="UserList_Total_count_img"
                  src={
                    table === 0
                      ? require("assets/user.svg").default
                      : table === 1 || table === 2 || table === 3
                      ? require("assets/user.svg").default
                      : " "
                  }
                  alt="Rectangle 16663"
                  className={cn(styles.box1, styles.box1_layout)}
                />
              </div>
            </div>
          </div>
          <div className={cn(styles.block2_spacer)} />
          <div
            id="UserList_Total_count_TextBlock"
            className={cn(styles.block2_item1)}
          >
            <div
              id="UserList_Total_count_TextBlock1"
              className={cn(styles.block3, styles.block3_layout)}
            >
              <h3
                id="UserList_Total_count_title"
                className={cn(styles.subtitle1, styles.subtitle1_layout)}
              >
                {"Total Count"}
              </h3>
              <h3
                id="UserList_Total_count_value"
                className={cn(styles.subtitle3, styles.subtitle3_layout)}
              >
                {userCount}
              </h3>
            </div>
          </div>
        </div>
      </div>

      <div
        id="UserList_Subtitle_text_block"
        style={{ display: "flex", justifyContent: "space-between" }}
        className={cn(styles.flex3, styles.flex5_layout)}
      >
        <div
          id="UserList_Subtitle_text_layout"
          className={cn(styles.flex6_layout)}
        >
          <div id="UserList_Subtitle_text" className={cn(styles.flex2_item)}>
            <h3
              id="UserList_Subtitle_Heading_Admin"
              className={
                table === 0
                  ? cn(styles.subtitle, styles.subtitle_layout)
                  : cn(styles.subtitle4, styles.subtitle1_layout)
              }
              onClick={() => {
                setTable(0);
                tabTemp = "active";
                localStorage.setItem("lastTableSearch", "");
              }}
              style={{ cursor: "pointer" }}
            >
              {"Admin"}
            </h3>
          </div>
          <div className={cn(styles.flex5_spacer)} />
          <div id="UserList_Subtitle_text1" className={cn(styles.flex2_item)}>
            <h3
              id="UserList_Subtitle_Heading_Operator"
              className={
                table === 1
                  ? cn(styles.subtitle, styles.subtitle_layout)
                  : cn(styles.subtitle2, styles.subtitle2_layout)
              }
              onClick={() => {
                setTable(1);
                tabTemp = "active";
                localStorage.setItem("lastTableSearch", "");
              }}
              style={{ cursor: "pointer" }}
            >
              {"Operator"}
            </h3>
          </div>
          <div className={cn(styles.flex5_spacer)} />
          <div id="UserList_Subtitle_text2" className={cn(styles.flex2_item)}>
            <h3
              id="UserList_Subtitle_Heading_Driver"
              className={
                table === 2
                  ? cn(styles.subtitle, styles.subtitle_layout)
                  : cn(styles.subtitle4, styles.subtitle1_layout)
              }
              onClick={() => {
                setTable(2);
                tabTemp = "active";
                localStorage.setItem("lastTableSearch", "");
              }}
              style={{ cursor: "pointer" }}
            >
              {"Driver"}
            </h3>
          </div>
          <div className={cn(styles.flex5_spacer)} />
          {/* <div id="UserList_Subtitle_text2" className={cn(styles.flex2_item)}>
            <h3
              id="UserList_Subtitle_Heading_Driver"
              className={
                table === 3
                  ? cn(styles.subtitle, styles.subtitle_layout)
                  : cn(styles.subtitle4, styles.subtitle1_layout)
              }
              onClick={() => {
                setTable(3);
                tabTemp = "active";
                localStorage.setItem("lastTableSearch", "");
              }}
              style={{ cursor: "pointer" }}
            >
              {"Roles"}
            </h3>
          </div> */}
        </div>
        <div className={cn(styles.flex5_spacer)} />
        <div className={cn(styles.flex3_item1)}>
          <Link
            to={
              table === 0
                ? "/Users/addAdmin"
                : table === 1
                ? "/Users/addOperator"
                : table === 2
                ? "/Users/addDriver"
                : table === 3
                ? "/Users/addRole"
                : " "
            }
          >
            <div
              id="UserList_Add_button_layout"
              className={cn(styles.add_button7, styles.add_button7_layout)}
            >
              <div
                id="UserList_Add_button"
                className={cn(styles.add_button7_item)}
              >
                <div
                  id="UserList_Add_buttonBox"
                  className={cn(
                    styles.add_button_box6,
                    styles.add_button_box6_layout
                  )}
                >
                  <div
                    id="UserList_Add_buttonBox1"
                    className={cn(styles.add_button7_item)}
                  >
                    <img
                      id="UserList_Add_buttonImg"
                      src={require("assets/Vector (5).png").default}
                      alt="Rectangle 16663"
                    />
                  </div>
                </div>
              </div>

              <div className={cn(styles.add_button7_spacer)} />

              <div
                id="UserList_Add_buttonText"
                className={cn(
                  styles.add_button_text_body,
                  styles.add_button_text_body_layout
                )}
              >
                {table === 0
                  ? "Add Admin"
                  : table === 1
                  ? " Add Operator"
                  : table === 2
                  ? " Add Driver"
                  : table === 3
                  ? " Add Role"
                  : " "}
              </div>
            </div>
          </Link>
        </div>
      </div>

      <div
      // className={cn(styles.flex4, styles.flex4_layout)}
      >
        {/* <div className={cn(styles.flex4_spacer)} /> */}
        {table === 0 ? (
          <Admin
            userCount={setUserCount}
            tigger={tempTigger}
            tabTemp={tabTemp}
            headerFilter={props.headerFilter}
          />
        ) : table === 1 ? (
          <Operator
            userCount={setUserCount}
            tigger={tempTigger}
            tabTemp={tabTemp}
            headerFilter={props.headerFilter}
          />
        ) : table === 2 ? (
          <Driver
            userCount={setUserCount}
            tigger={tempTigger}
            tabTemp={tabTemp}
            headerFilter={props.headerFilter}
          />
        ) : table === 3 ? (
          <RoleList
            userCount={setUserCount}
            tigger={tempTigger}
            tabTemp={tabTemp}
            headerFilter={props.headerFilter}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

export default function UserList(props) {
  const [headerFilter, setHeaderFilter] = useState(true);
  return (
    <>
      <Master
        opts={props}
        screen={UserListView}
        showStatus={false}
        headerFilter={headerFilter}
        setHeaderFilter={setHeaderFilter}
      />
    </>
  );
}

UserList.inStorybook = true;
